import { OrderItemRefundSummaryResponse } from '../api/responses';
import { OrderItemRefundSummary } from '../models';

export const orderItemRefundSummaryFromResponse = (
  response: OrderItemRefundSummaryResponse,
): OrderItemRefundSummary => {
  return new OrderItemRefundSummary({
    refundedPrice: response.refundedPrice,
    originalPrice: response.originalPrice,
    currentPrice: response.currentPrice,
    refundedQuantity: response.refundedQuantity,
    currentQuantity: response.currentQuantity,
    originalQuantity: response.originalQuantity,
    fullyRefunded: response.fullyRefunded,
  });
};
